import { useParams } from "react-router-dom";
import { useGetServiceDetails } from "../../../../../hooks/api/queries/useInventory";

export const useEditService = () => {
  const params = useParams();

  const { isLoading: isFetchingService, data: serviceDetails } =
    useGetServiceDetails(params.id);

  return {
    isFetchingService,

    serviceDetails,
  };
};
